var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5V14.5M11.5 17.5V8.5M16.5 17.5V13.5M21.5 5.5C21.5 6.29565 21.1839 7.05871 20.6213 7.62132C20.0587 8.18393 19.2956 8.5 18.5 8.5C17.7044 8.5 16.9413 8.18393 16.3787 7.62132C15.8161 7.05871 15.5 6.29565 15.5 5.5C15.5 4.70435 15.8161 3.94129 16.3787 3.37868C16.9413 2.81607 17.7044 2.5 18.5 2.5C19.2956 2.5 20.0587 2.81607 20.6213 3.37868C21.1839 3.94129 21.5 4.70435 21.5 5.5Z",
    stroke: "#A2A4AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.496 11C21.496 11 21.5 11.34 21.5 12C21.5 16.478 21.5 18.718 20.109 20.109C18.718 21.5 16.479 21.5 12 21.5C7.522 21.5 5.282 21.5 3.891 20.109C2.5 18.718 2.5 16.479 2.5 12C2.5 7.522 2.5 5.283 3.891 3.891C5.282 2.5 7.521 2.5 12 2.5H13",
    stroke: "#A2A4AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.f065681e7cd2a543599ab52392a685eb.svg";
export { ForwardRef as ReactComponent };